import React, { useState, useEffect, useContext } from "react";
import { Typography, Input, Tooltip, Button, Dropdown, Menu, Icon, message } from "antd";
import "./index.less";
import { platformApi } from "../../../api";
import { ContextAPI } from "../../../ContextAPI";
import { withRouter } from "react-router-dom";
import { LeftOutlined } from "@ant-design/icons";

// Components
import BinLocationTable from "./BinLocationTable";
import WrappedBinLocationModal from "./BinLocationForm";

const { Title } = Typography;
const { Search } = Input;
const { Item } = Menu;

const BinLocation = (props) => {
  const [limit, setLimit] = useState(10);
  const [addFlag, setAddFlag] = useState(false);
  const [editFlag, setEditFlag] = useState(false);
  const [selected, setSelected] = useState(null);
  const [dataSource, setData] = useState([]);
  const [spinning, setSpinning] = useState(false);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const [createAccess, setCreateAccess] = useState(false);
  const [modifyAccess, setModifyAccess] = useState(false);
  const [search, setSearch] = useState(null);
  const { loginCredintials } = useContext(ContextAPI);

  const getMenu = () => {
    let size = count / 10 + (count % 10 ? 1 : 0);
    const menus = [];
    menus.push(10);
    size = size <= 10 ? size : 10;
    for (let itr = 2; itr <= size; itr++) menus.push(itr * 10);
    return menus.map((menu) => (
      <Item
        onClick={() => {
          setLimit(menu);
          setPage(1);
        }}
        key={menu}
      >
        {menu}
      </Item>
    ));
  };

  const menu = <Menu>{getMenu()}</Menu>;

  useEffect(() => {
    setPrimaryData();
    if (loginCredintials.roleAccess) {
      loginCredintials.roleAccess.forEach((each) => {
        if (each.subModule === "bin_location") {
          if (each.access.create) {
            setCreateAccess(true);
          }
          if (each.access.update) {
            setModifyAccess(true);
          }
        }
      });
    }
  }, []);

  useEffect(() => {
    setPrimaryData(search);
  }, [page, limit, search]);

  const setPrimaryData = (searchStr, val) => {
    setSpinning(true);
    platformApi
      .post("/api/binLocation/get", {
        page: val ? val : page,
        size: limit,
        searchString: searchStr !== undefined ? searchStr : search,
      })
      .then((result) => {
        setSpinning(false);
        const { data } = result;
        if (data.code === 200) {
          const { response } = data;
          if (response.code === 200) {
            setData(response.data.binLocation || []);
            setCount(response.data.count || 0);
          } else {
            message.error("Unable to fetch Bin Locations", 2);
          }
        } else {
          message.error("Unable to fetch Bin Locations", 2);
        }
      })
      .catch((error) => {
        setSpinning(false);
        console.error("Error on Bin Location: ", error);
        message.error("Unable to fetch Bin Locations", 2);
      });
  };

  const deleteData = (id) => {
    setSpinning(true);
    let temp = page !== 1 && dataSource.length === 1;
    platformApi
      .delete(`/api/binLocation/${id}`)
      .then((result) => {
        setSpinning(false);
        const { data } = result;
        if (data.code === 200) {
          const { response } = data;
          if (response.code === 200) {
            if (temp) {
              setPage(1);
              setPrimaryData(null, 1);
            } else {
              setPrimaryData();
            }
            message.success("Deleted Successfully", 2);
          } else {
            message.error("Unable to delete Bin Location", 2);
          }
        } else {
          message.error("Unable to delete Bin Location", 2);
        }
      })
      .catch((error) => {
        setSpinning(false);
        message.error("Unable to delete Bin Location", 2);
        console.error("Error on Bin Location: ", error);
      });
  };

  const addData = (binLoc) => {
    setSpinning(true);
    if (binLoc.id) {
      platformApi
        .put(`/api/binLocation/${binLoc.id}`, binLoc)
        .then((result) => {
          setSpinning(false);
          const { data } = result;
          if (data.code === 200) {
            const { response } = data;
            if (response.code === 200) {
              setPrimaryData();
              message.success("Bin Location updated successfully", 2);
            } else {
              message.error("Unable to save Bin Location", 2);
            }
          } else {
            message.error("Unable to save Bin Location", 2);
          }
        })
        .catch((error) => {
          message.error("Unable to save Bin Location", 2);
          console.error("Error on Bin Location: ", error);
          setSpinning(false);
        });
    } else {
      platformApi
        .post("/api/binLocation", binLoc)
        .then((result) => {
          setSpinning(false);
          const { data } = result;
          if (data.code === 200) {
            const { response } = data;
            if (response.code === 200) {
              setPrimaryData();
              message.success("Bin Location added successfully", 2);
            } else {
              message.error("Unable to add Bin Location", 2);
            }
          } else {
            message.error("Unable to add Bin Location", 2);
          }
        })
        .catch((error) => {
          message.error("Unable to add Bin Location", 2);
          console.error("Error on Bin Location: ", error);
          setSpinning(false);
        });
    }
  };

  return (
    <div>
      <div className="bin-location-head">
        <Title style={{ width: "60%" }} level={4}>
          <Tooltip placement="topLeft" title={"Back to Company Master"}>
            <Button
              style={{ margin: "0 20px" }}
              onClick={() => props.history.push("/autoadmin/company")}
            >
              <LeftOutlined />
            </Button>
          </Tooltip>
          Bin Location [{count}]
          <span style={{ marginLeft: "1rem" }}>
            <Dropdown overlay={menu} trigger={["click"]}>
              <Button>
                {limit}
                &nbsp;
                <Icon type="down" />
              </Button>
            </Dropdown>
          </span>
        </Title>
        <Search
          style={{ width: "30%" }}
          placeholder="Search Bin Location / Branch"
          onSearch={(event) => {
            setPage(1);
            setSearch(event);
          }}
          onChange={(event) => {
            if (event.target.value === "") {
              setSearch(null);
              setPage(1);
            }
          }}
        />
        <Button
          onClick={() => {
            setEditFlag(true);
            setAddFlag(true);
          }}
          style={{ margin: "0 3%", width: "20%" }}
          type="primary"
          disabled={!createAccess}
        >
          Add Bin Location
        </Button>
      </div>
      <BinLocationTable
        pagination={{
          onChange: (page) => {
            setPage(page);
          },
          pageSize: limit,
          defaultCurrent: 1,
          total: count,
          current: page,
          showQuickJumper: true,
        }}
        openModal={(id, editable) => {
          setSelected(id);
          setEditFlag(editable);
          setAddFlag(true);
        }}
        delete={(id) => deleteData(id)}
        dataSource={dataSource}
        spinner={{ spinning }}
      />
      <WrappedBinLocationModal
        data={dataSource.find((item) => item.id === selected)}
        emitData={(data) => addData(data)}
        open={addFlag}
        editable={editFlag}
        close={() => {
          setSelected(null);
          setAddFlag(false);
        }}
        modify={modifyAccess}
      />
    </div>
  );
};

export default withRouter(BinLocation);
